<aside class="menu" [ngClass]="{'is-active': isMenuOpen}">
    @for (menuItem of itemsMenu; track menuItem.section) {
      <div class="section-links">
        @if(menuItem.section) {
          <h4 class="title-section">{{ menuItem.section }}</h4>
        }
        <div class="section-container">
          @for (box of menuItem.boxes; track box.name) {
            <div>
              <div class="option-boxes">
                <div class="option-box" [routerLink]="[box.routerLink]" >
                  <fa-duotone-icon class="box-icon" [icon]="box.icon" [swapOpacity]="box.swapOpacity"></fa-duotone-icon>
                  <span class="box-title" [ngClass]="{'is-active-link': isActiveLink(box)}">{{ box.nameLong ? box.nameLong : box.name }}</span>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </aside>
  